export const SUMMARY_STATUS_PAGE_TEXT = {
  APPLICATION_SUMMARY: 'Application Summary',
  APPLICATION: 'Application',
  PAYMENT_STATUS: 'Application Fee',
  ACADEMIC_REFEREE_STATUS: 'Academic Referee Status',
  SUPERVISOR_INVITATION: 'Supervisor Invitation',
  RETURN_REMARKS: 'Return Remark(s)',
  OFFER_STATUS: 'Offer Status',
  SEAT_RESERVATION_STATUS: 'Seat Reservation',
  VISA_APPLICATION: 'Student Visa Application',
  DEBIT_NOTE: 'Registration Fee',
  TUITION_FEE_PAYMENT: 'Tuition Fee and Caution Money',
  REGISTRATION_PREPARATION: 'Registration Preparation',
  CONDITIONAL_OFFER_CONFIRMATION: 'Meeting Condition(s)',
  ONLINE_REGISTRATION: 'Online Registration',
  OFFER_ACCEPTANCE: 'Offer Acceptance',
  QUALIFICATION_CHECK: 'Qualification Verification',
  APPLICATION_FEE_BANNER: `
    Admission offers will normally be made between February and June (for September entry), June and October (for January entry), and November and February (for May entry). If you wish to check the progress of your application, you may directly approach the academic department concerned. Please click <a class="banner-link" target="_blank" href="https://www.polyu.edu.hk/gs/docdrive/Others/rpg_dept_contacts.pdf">here</a> for the contact details of the relevant academic departments.
  `,
};

export const PROGRAMME_LEVEL_PAGE_TEXT = {
  M: 'Master of Philosophy',
  D: 'Doctor of Philosophy',
};

export const HELPER_TEXT_RETURN =
  'Please carefully review the remarks provided with your returned application. Ensure that you address each point thoroughly before resubmitting your application.';

export const PROGRESS_NOTIFICATION_TEXT = {
  OFFER_ACCEPTED_NOTE: `Please read the “<a href='https://www.polyu.edu.hk/gs/docdrive/Notice/GSnotice2024_71.pdf' target="_blank" rel="noopener noreferrer">Notice of Commencement of 2024/25 Academic Year, Semester Two - New Research Postgraduate Students</a>” and “<a href='https://www.polyu.edu.hk/gs/current-students/useful-information-for-new-research-postgraduate-students/' target="_blank" rel="noopener noreferrer">Useful Information for New Research Postgraduate Students</a>” before proceeding with the online registration and commencement of study.  `,
  OFFER_LAPSED: 'Your offer has lapsed.',
  CONDITION_MET_LAPSED:
    'Your offer has lapsed because the conditions were not met.',
};
